import type { FC } from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '@components/ui/dropdown-menu';
import { POPOVER_Z_INDEX } from '@constants/z-indices';
import clsx from 'clsx';
import { ChevronDown } from 'lucide-react';

import { selectAvailableTabs, usePDFPreviewStore } from '../store/pdf-preview.store';

import { fileNameWrapperClasses } from './classes';

interface SplitSelectorProps {
  currentFileName: string;
}

export const SplitSelector: FC<SplitSelectorProps> = ({ currentFileName }) => {
  const { activeTabId, splitTabId, setSplitTab, availableTabs } = usePDFPreviewStore((state) => ({
    activeTabId: state.activeTabId,
    splitTabId: state.splitTabId,
    setSplitTab: state.setSplitTab,
    availableTabs: selectAvailableTabs(state),
  }));

  const selectableForSplitTabs = availableTabs.filter((tab) => tab.id !== activeTabId);
  const hasMultipleOptions = selectableForSplitTabs.length > 1;

  if (!hasMultipleOptions) {
    return (
      <div className={clsx(fileNameWrapperClasses)}>
        <p className="truncate text-xs leading-5 font-normal text-gray-600">{currentFileName}</p>
      </div>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className={clsx(fileNameWrapperClasses, 'cursor-pointer')}>
          <p className="truncate text-xs leading-5 font-normal text-gray-600">{currentFileName}</p>
          <ChevronDown className="ml-1 size-3.5 transition-transform" />
        </button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="start" className={clsx('min-w-[200px]', POPOVER_Z_INDEX)}>
        <DropdownMenuRadioGroup value={splitTabId ?? ''} onValueChange={(value) => setSplitTab(value)}>
          {selectableForSplitTabs.map((tab) => (
            <DropdownMenuRadioItem key={tab.id} value={tab.id} className="text-xs">
              {tab.fileName ?? tab.label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
